import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Tooltip from "@shared/v2/Tooltip";
import IconButton from "@shared/v2/IconButton";
import { PhoneSolidV6 } from "@shared/v2/Icomoon";
import { prospectDisabled } from "./helpers";

const getTooltipContent = (prospect) => {
  if (prospect.isDnc) return "Calling is disabled for this number due to DNC regulations.";
  if (!prospect.phone) return "Cannot call a prospect with no phone number.";
  if (prospectDisabled(prospect))
    return "Someone on your team has already added this potential owner as a lead.";
  return "Call prospect";
};

const CallButton = ({ onClick, placement, prospect, withIcon }) => (
  <Tooltip
    placement={placement}
    innerClassName="tw-max-w-[240px]"
    trigger={
      withIcon ? (
        <IconButton
          size="small"
          onClick={onClick}
          disabled={!prospect.phone || prospect.isDnc || prospectDisabled(prospect)}
        >
          <PhoneSolidV6 />
        </IconButton>
      ) : (
        <Button
          size="small"
          onClick={onClick}
          disabled={!prospect.phone || prospect.isDnc || prospectDisabled(prospect)}
        >
          Call
        </Button>
      )
    }
    content={getTooltipContent(prospect)}
  />
);

CallButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  placement: PropTypes.string,
  prospect: PropTypes.shape({
    phone: PropTypes.string,
    isDnc: PropTypes.bool,
  }).isRequired,
  withIcon: PropTypes.bool,
};

CallButton.defaultProps = {
  placement: "left",
  withIcon: false,
};

export default CallButton;
